export default "__VITE_ASSET__BOgoGQHm__"